<template>
    <div class="message-detail">
      <title-screen title="22" v-show="isEmergency"></title-screen>
      <title-screen title="23" v-show="!isEmergency"></title-screen>
      <div class="message-info" v-if="isExistMessage">
        <table class="table">
          <tbody>
            <tr>
                <td class="title">題名</td>
                <td>{{title}}</td>
            </tr>
            <tr>
                <td class="title">表示期間</td>
                <td>{{dspPeriod}}</td>
            </tr>
            <tr>
                <td class="title">種別</td>
                <td>{{messageType}}</td>
            </tr>
            <tr>
                <td class="title">内容</td>
                <td v-html="content"  id="message-content"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center mt1 not-exist-msg" v-else><p>緊急メッセージ・お知らせが存在しません。</p></div>
  </div>
</template>
<script>
import messageDetail from '@/api/message-detail/message-detail.js'
import TitleScreen from '../../../../components/common/TitleScreen'
import moment from 'moment'

export default {
  components: { TitleScreen },
  data () {
    return {
      title: '',
      content: '',
      dspPeriod: '',
      messageType: '緊急メッセージ',
      isExistMessage: true,
      isEmergency: true
    }
  },
  created () {
    const messageId = this.$route.params.id
    let _this = this
    messageDetail.messageDetail(messageId).then(response => {
      if (response.data.status === 200) {
        this.title = response.data.data.title
        this.content = response.data.data.content
        this.dspPeriod = this.formatDate(response.data.data.dspStart) + '～' + this.formatDate(response.data.data.dspEnd)
        if (response.data.data.messageType === 2) {
          this.messageType = 'お知らせ'
          _this.isEmergency = false
        }
      } else {
        _this.isExistMessage = false
      }
    })
  },
  methods: {
    formatDate (date, format = 'YYYY年MM月DD日', defaultValue = null) {
        if (date !== null && date !== undefined) {
            return moment.parseZone(date).format(format)
        } else {
            return defaultValue
        }
    }
  }
}
</script>
<style>
  .message-info .table {
    background: #fff;
    border-left: 2px solid #c0b283;
    border-top: 2px solid #c0b283;
    width: 100%;
  }

  _:-ms-lang(x)::-ms-backdrop, .message-info .table {
    table-layout: fixed;
  }

  .message-info .table .title,
  .message-info .table td {
    border-bottom: 2px solid #c0b283;
    border-right: 2px solid #c0b283;
    padding: 1em;
  }

  .message-info .table td,
  .message-info .table td input,
  .message-info .table td span {
    font-size: 16px !important;
  }

  .message-info .table td.title {
    font-size: 16px !important;
  }

  .message-info .table .title {
    background: #f7f0df;
    font-weight: bold;
    text-align: left;
    width:300px;
  }

  .message-info .table td {
    vertical-align: middle;
    background: #fffdf7;
  }

  .message-info .table a {
    color: #3a8ee6;
  }

  @media screen and (max-width: 768px) {
    .message-info .table .title {
      width: 50%;
    }
  }
  .not-exist-msg {
      font-size: 24px !important;
  }

  #message-content figure img {
      max-width: 100%;
  }
</style>
